/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Link_Web_PlaceholderInputs */

const en_dialog_link_web_placeholder = /** @type {(inputs: Dialog_Link_Web_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.sitename.com/article`)
};

const es_dialog_link_web_placeholder = /** @type {(inputs: Dialog_Link_Web_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.sitename.com/article`)
};

/**
* | output |
* | --- |
* | "https://www.sitename.com/article" |
*
* @param {Dialog_Link_Web_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_link_web_placeholder = /** @type {((inputs?: Dialog_Link_Web_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Link_Web_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_link_web_placeholder(inputs)
	return en_dialog_link_web_placeholder(inputs)
});